import { IconType } from '@awell-health/design-system'
import { DataPointValueType, ExtensionActionFieldType } from '../../../../generated/types-orchestration'

export const mapFieldTypeIcon = (fieldType: ExtensionActionFieldType | DataPointValueType): IconType => {
  switch (fieldType) {
    case ExtensionActionFieldType.Boolean:
    case DataPointValueType.Boolean:
      return 'RiCheckboxCircleLine'
    case ExtensionActionFieldType.Date:
    case DataPointValueType.Date:
      return 'RiCalendarLine'
    case ExtensionActionFieldType.Json:
    case DataPointValueType.Json:
      return 'RiBracesLine'
    case ExtensionActionFieldType.Numeric:
    case DataPointValueType.Number:
      return 'RiHashtag'
    case ExtensionActionFieldType.NumericArray:
    case DataPointValueType.NumbersArray:
      return 'RiListOrdered2'
    case ExtensionActionFieldType.String:
    case DataPointValueType.String:
      return 'RiText'
    case ExtensionActionFieldType.StringArray:
    case DataPointValueType.StringsArray:
      return 'RiListCheck'
    case ExtensionActionFieldType.Text:
      return 'RiText'
    case ExtensionActionFieldType.Html:
      return 'RiCodeFill'
    case DataPointValueType.Attachment:
      return 'RiAttachment2'
    case DataPointValueType.AttachmentsArray:
      return 'RiAttachment2'
    case DataPointValueType.Telephone:
      return 'RiPhoneLine'
    default:
      return 'RiQuestionLine'
  }
}
